// functions.js
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const keepValueOnly = (data, getKeyOnly) => {
  const rfvNames = Object.values(data).map(item => item[getKeyOnly]);
  const result = rfvNames.join(', ');
  return result;
};

const Gender = (gender) => {

   switch(gender.toUpperCase()) {
    case 'M':
      return 'Male';
    case 'F':
      return 'Female';
    default:
      return '';
  }
};

const notify = (type = 'success', message = '') => {
  const options = {
    position: 'top-right',
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  };
    
  if (type === 'success') {
    toast.success(message, options);
  } else { 
    toast.error(message, options);      
  }
};

const localData = (keyName, isRemove = false) => {
  if (isRemove === false) {
    const isLocalDataExists = localStorage.getItem(keyName) !== null;
    if (isLocalDataExists) {
      const storedLocalData = localStorage.getItem(keyName);
      try {
        return JSON.parse(storedLocalData);
      } catch (error) { }
      return storedLocalData;
    } else {
      return null;
    }
  } else { 
    try {
      keyName.forEach((key) => {
          localStorage.removeItem(key);
      });
    } catch (error) { }
    return true;
  }
};


const Age = (birth) => {
  const today = new Date();
  const birthdate = new Date(birth);
    
  let age = today.getFullYear() - birthdate.getFullYear();
  if (
    today.getMonth() < birthdate.getMonth() ||
    (today.getMonth() === birthdate.getMonth() && today.getDate() < birthdate.getDate())
  ) {
    age--;
  }
  if (age > 0) {  age = age +'y' }
  return age;
};


const usDate = (dateString, includeTime = false) => {
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return '';
  }

  const options = {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    ...(includeTime && {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    }),
  };

  return date.toLocaleString('en-US', options);
};

const getData = async (url, setData) => {
  try {
    const response = await axios.get(url);
    if (response.status === 200) {
      if (setData === true) {
        return response.data;
      } else {
        setData(response.data);
      }  
    }
  } catch (error) {
    console.error(`Error fetching data from ${url}:`, error);
  }
};

const postData = async (url, setData, input) => {
  try {
    const headers = { 'Accept': 'application/json' }
    const response = await axios.post(url, input, { headers });
    if (response.status === 200) {
      if (setData === true) {
        return response.data;
      } else {
        setData(response.data);
      }      
    }
  } catch (error) {
    console.error(`Error fetching data from ${url}:`, error);
  }
};

const usPhoneFormat = (phone) => {
  const cleaned = ('' + phone).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }

  return phone;
};


export { usDate, getData, postData, localData, notify, keepValueOnly, Age, Gender, usPhoneFormat};
